import React, { useState } from 'react'

export default function ContactSupport() {

    return (
        <div className='PageContent'>
            <span>Contact support</span>
        </div>
    )
}